import { TextModuleFields, TextModuleProps } from '../types/TextModule.types'
import { StringField, ImageField } from '../../../types/types'
import { TextModuleMock } from '../../../mocks/TextModule.mock'
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-react/types/components/Link'

export class TextModuleModel {
  private readonly fields?: TextModuleFields

  constructor(props: TextModuleProps) {
    this.fields = props.fields
  }

  get AlignToAccordion(): StringField {
    return this.fields?.AlignToAccordion ?? { value: '' }
  }

  get bodyText(): StringField {
    return this.fields?.BodyText ?? TextModuleMock?.fields?.BodyText
  }

  get eyebrow(): StringField {
    return this.fields?.Eyebrow ?? TextModuleMock?.fields?.Eyebrow
  }

  get title(): StringField {
    return this.fields?.Title ?? TextModuleMock?.fields?.Title
  }

  get subtitle(): StringField {
    return this.fields?.Subtitle ?? TextModuleMock?.fields?.Subtitle
  }

  get link1(): LinkFieldValue {
    return (
      this.fields?.PrimaryLink?.value ??
      TextModuleMock?.fields?.PrimaryLink?.value
    )
  }

  get link2(): LinkFieldValue {
    return (
      this.fields?.SecondaryLink?.value ??
      TextModuleMock?.fields?.SecondaryLink?.value
    )
  }

  get image(): ImageField {
    return this.fields?.Image ?? TextModuleMock?.fields?.Image
  }

  get imageMobile(): ImageField {
    return this.fields?.ImageMobile ?? TextModuleMock?.fields?.Image
  }
  get AllowFallbackForMobile(): boolean {
    return !!this.fields?.AllowFallbackForMobile?.value
  }

  get textPosition(): StringField {
    return (
      this.fields?.Alignment?.fields?.Key ??
      TextModuleMock?.fields?.Alignment?.fields?.Key
    )
  }

  get abstract(): StringField | undefined {
    return this.fields?.Abstract
  }

  get variant(): StringField | undefined {
    return this.fields?.Variant
  }
}
